<div class="grid gap-4 md:grid-cols-2">
  <div
    *ngFor="let section of sections"
    class="rounded-2xl border border-gray-200 bg-white/70 p-4 dark:border-[#191e3a] dark:bg-white/5"
  >
    <h4 class="mb-3 text-sm font-semibold text-gray-800 dark:text-white">{{ section.title }}</h4>
    <dl class="space-y-1.5">
      <div
        *ngFor="let field of section.fields"
        class="flex items-start justify-between gap-3 text-xs"
        [ngClass]="isChanged(field.path) ? 'rounded-md bg-amber-50 px-1.5 dark:bg-amber-950' : ''"
      >
        <dt class="text-gray-500 dark:text-gray-400">
          {{ field.label }}
          <span *ngIf="isLocked(field.path)" title="Compliance-locked" aria-label="Compliance-locked">🔒</span>
        </dt>
        <dd class="text-right font-medium text-gray-800 dark:text-gray-200">
          <span *ngIf="isChanged(field.path)" class="mr-1 text-gray-400 line-through">{{ oldValue(field.path) }}</span>
          {{ value(field.path) }}
        </dd>
      </div>
    </dl>
  </div>
</div>
